/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_LoadingInputs */

const en_us2_onboarding_loading = /** @type {(inputs: Onboarding_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading your answers…`)
};

const pt_br2_onboarding_loading = /** @type {(inputs: Onboarding_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando suas respostas…`)
};

const es_419_onboarding_loading = /** @type {(inputs: Onboarding_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando tus respuestas…`)
};

const pt_pt2_onboarding_loading = /** @type {(inputs: Onboarding_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A carregar as tuas respostas…`)
};

const fr_fr2_onboarding_loading = /** @type {(inputs: Onboarding_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement de tes réponses…`)
};

const de_de2_onboarding_loading = /** @type {(inputs: Onboarding_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Antworten werden geladen…`)
};

const it_it2_onboarding_loading = /** @type {(inputs: Onboarding_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento delle risposte…`)
};

/**
* | output |
* | --- |
* | "Loading your answers…" |
*
* @param {Onboarding_LoadingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_loading = /** @type {((inputs?: Onboarding_LoadingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_LoadingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_loading(inputs)
	if (locale === "es-419") return es_419_onboarding_loading(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_loading(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_loading(inputs)
	if (locale === "de-DE") return de_de2_onboarding_loading(inputs)
	if (locale === "it-IT") return it_it2_onboarding_loading(inputs)
	return en_us2_onboarding_loading(inputs)
});
export { onboarding_loading as "onboarding.loading" }